import { t } from "../i18n";

// A search over the rows under it (byj-1wv.51.6): an icon, the field, and
// while it holds anything how many rows it leaves of how many, and ✕ to clear
// it. The dashboard's list of sessions and the management page's recordings.

export function ListSearch({ value, onChange, label, shown, of }: {
  value: string;
  onChange: (v: string) => void;
  /** the field's name and placeholder: what it searches */
  label: string;
  shown: number;
  of: number;
}) {
  return (
    <div className="list-search" role="search">
      <svg className="list-search-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M15.5 15.5 21 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <input type="search" value={value} onChange={(e) => onChange(e.target.value)} placeholder={label} aria-label={label} />
      {value.trim() !== "" && (
        <>
          <span className="list-search-count" aria-live="polite">
            {t("classes:searchCount", { n: shown, of })}
          </span>
          <button type="button" className="list-search-clear" aria-label={t("classes:clearSearch")} onClick={() => onChange("")}>
            ✕
          </button>
        </>
      )}
    </div>
  );
}
